(function () {
    'use strict';

    angular
        .module('homeDashboardControllers')
        .controller('DashboardInitiativeManagementController', Controller);

    Controller.$inject = ['$scope', '$state', 'permissionService'];

    function Controller($scope, $state, permissionService) {
        $scope.getInitiativeManagementUrl = function () {
            // TODO: Get filters from BE
            return $state.href('advancedSearch', {
                sourceType: 'PlanInitiative',
                sf: '99;-CreationStatusValue:ReadyForTracking'
            }) + '#mode=manageInitiatives';
        };

        $scope.canManageInitiatives =
            permissionService.hasPermission('GRCInitiativeUpdateStatusManagement', 'PlanInitiative', 'Manage');
    }
})();